import React, { useEffect, useRef, useState } from "react";

import CancelIcon from "@mui/icons-material/Cancel";

import {
  Backdrop,
  Button,
  createTheme,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import DoughnutGraph1 from "./DoughnutGraph1";
import PieGraph1 from "./PieGraph1";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { common_axios } from "../../../App";
import DashboradTable from "./DashboradTable";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as yup from "yup";
import moment from "moment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Swal from "sweetalert2";
import { useFormik } from "formik";
export default function Dashboard() {
  const [open, setOpen] = useState(false);
  const [date, setdate] = useState({
    year: new Date().getFullYear(),

    month: moment(new Date()).format("MMMM YYYY"),
  });

  const [showPassword3, setShowPassword3] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const [dataTime, seDataTime] = useState({
    graph1: null,
    line1: null,
    pie1: null,
    pie2: null,
    pie3: null,
    pie4: null,
  });

  const handleClickShowPassword3 = () => setShowPassword3(!showPassword3);
  const handleMouseDownPassword3 = () => setShowPassword3(!showPassword3);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);

  const approvval = useRef(null);

  const markAttendacnerefrr = useRef(null);

  const validationSchema = yup.object({
    newPassword: yup
      .string()
      .required("Please Enter your  password")
      .min(8)
      .max(40)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(`api/auth/v1/changePassword`, {
          newPassword: values.newPassword,
          reTypePassword: values.confirmPassword,
          userId: localStorage.getItem("UserId"),
        });

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.success(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);

          let firstTime = await JSON.parse(localStorage.getItem("usermodal"));

          firstTime.firstTimeLogIn = 1;
          await localStorage.setItem("usermodal", JSON.stringify(firstTime));
          await markAttendacnerefrr?.current?.click();
          await formik.handleReset();
        } else {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.error(res.data.statusDescription.description, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        console.log(error);

        await setTimeout(async () => {
          // await toast.error(
          //   "Something went wrong!! Please check your network",
          //   {
          //     theme: "colored",
          //   }
          // );
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something Went Wrong !! Please check your network ",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });

  const userDetails = JSON.parse(
    localStorage.getItem("usermodal")
  )?.firstTimeLogIn;

  useEffect(() => {
    if (userDetails == 0) {
      approvval?.current?.click();
    }
  }, [userDetails]);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const approvvall = useRef(null);

  return (
    <main className="main-content position-relative border-radius-lg ">
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <Loader />
      </Backdrop>
      <button
        id="Change"
        ref={approvval}
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdrop98"
      >
        Launch static backdrop modal
      </button>

      <div
        className="modal mark fade"
        id="staticBackdrop98"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Change Password
                </h5>
                <button
                  ref={markAttendacnerefrr}
                  type="button"
                  className="d-none"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <ThemeProvider theme={theme}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <TextField
                        required
                        className="w-100"
                        label="New Password"
                        color="primary"
                        size="small"
                        type={showPassword2 ? "text" : "password"}
                        name="newPassword"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword2}
                              >
                                {showPassword2 ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.newPassword &&
                          Boolean(formik.errors.newPassword)
                        }
                        helperText={
                          formik.touched.newPassword &&
                          formik.errors.newPassword
                        }
                      />
                    </div>
                    <div className="col-md-6 ">
                      <TextField
                        required
                        className="w-100"
                        label="Confirm Password"
                        color="primary"
                        size="small"
                        type={showPassword3 ? "text" : "password"}
                        name="confirmPassword"
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword3}
                                onMouseDown={handleMouseDownPassword3}
                              >
                                {showPassword3 ? (
                                  <VisibilityIcon sx={{ color: "#85CBF2" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#85CBF2" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={formik.values.confirmPassword}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.confirmPassword &&
                          Boolean(formik.errors.confirmPassword)
                        }
                        helperText={
                          formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                        }
                      />
                    </div>
                  </div>
                </div>
              </ThemeProvider>
              <div className="modal-footer text-end">
                <Button
                  sx={{ marginLeft: "10px", background: "#F96902" }}
                  variant="contained"
                  endIcon={<CheckCircleIcon />}
                  type="submit"
                >
                  Confirm
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="home-section home_section ">
        <div class="container-fluid">
          <div class="row mb-3"></div>

          <div class="row mb-3"></div>

          <div class="row mt-3">
            <div class="col-md-12">
              <div class="card min_height">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12"></div>
                </div>

                <div class="container-fluid px_x8">
                  <DashboradTable />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
